import { v4 as uuidv4 } from 'uuid';

export const basicConditionBlank = {
    fact: '',
    operator: '',
    value: '',
};

export const deconstructRulesForDialog = (field) => {
    const validation = deconstructValidation(field.rules);
    const visibility = deconstructVisibility(field.visibilityConditions);

    return {
        visibility,
        validation,
    };
};

function deconstructValidation(rules) {
    let required = false;
    let validationRules = [];

    if (rules && Array.isArray(rules)) {
        // If rules array contains required field rule, indicate with required
        // boolean and filter out required rule from remaining rules
        if (rules.some((rule) => rule.event.type.toLowerCase().includes('require'))) {
            required = true;
            rules = rules.filter((rule) => !rule.event.type.toLowerCase().includes('require'));
        }

        // Convert remaining rules and return array of rule objects or empty array if no other rules
        validationRules = rules.map((rule) => {
            let advancedRequiredMsg = null;
            let advancedMode = false;

            if (checkComplexConditions(rule.conditions)) {
                advancedRequiredMsg = 'The conditions are too complex to display in basic mode';
                advancedMode = true;
            }
            return {
                booleanOperator: rule.conditions.any ? 'any' : 'all',
                conditions: rule.conditions.any ? rule.conditions.any : rule.conditions.all,
                message: rule.event.params.message,
                type: rule.event.type,
                advancedRequiredMsg: advancedRequiredMsg,
                advancedMode: advancedMode,
                advancedRules: advancedMode ? JSON.stringify(rule) : null,
            };
        });
    }

    return { required, validationRules };
}

export const checkComplexConditions = (rule) => {
    let conditions = rule.any ? rule.any : rule.all;
    for (let index = 0; index < conditions.length; index++) {
        let condition = conditions[index];
        if (
            condition.fact === null ||
            condition.fact === undefined ||
            condition.operator === null ||
            condition.operator === undefined ||
            condition.value === null ||
            condition.value === undefined ||
            Object.keys(condition).length !== 3
        ) {
            return true;
        }
    }
    return false;
};

function deconstructVisibility(visibility) {
    let advancedRequiredMsg = null;
    let advancedMode = false;
    let booleanOperator = 'all';
    let conditions = [];

    if (visibility) {
        if (checkComplexConditions(visibility)) {
            advancedRequiredMsg = 'The conditions are too complex to display in basic mode';
            advancedMode = true;
        }

        booleanOperator = visibility.any ? 'any' : 'all';
        conditions = visibility.any ? visibility.any : visibility.all;
    }

    return {
        booleanOperator,
        conditions,
        advancedRequiredMsg,
        advancedMode: advancedMode,
        advancedVisibility: advancedMode ? JSON.stringify(visibility) : null,
    };
}

export const constructRulesForSave = (field, currRules) => {
    //Concatenate validation rules
    const validation = currRules.validation;
    let validationRules = [];
    if (validation.required) {
        validationRules = [
            {
                conditions: {
                    all: [
                        {
                            fact: `${field.field}`,
                            operator: field.typeId === 'boolean' ? 'equal' : 'hasValue',
                            value: true,
                        },
                    ],
                },
                event: {
                    type: 'Required' + uuidv4(),
                    params: {
                        message: 'Required Field',
                    },
                },
            },
        ];
    }
    validationRules = [
        ...validationRules,
        ...validation.validationRules.map((rule) => {
            const conditions = rule.conditions.filter((condition) => {
                return condition.fact !== '' || condition.operator !== '' || condition.value !== '';
            });
            if (rule.advancedMode) {
                return parseJsonString(rule.advancedRules) || null;
            } else {
                if (conditions.length > 0) {
                    return {
                        conditions: {
                            [rule.booleanOperator]: conditions,
                        },
                        event: {
                            type: rule.type,
                            params: {
                                message: rule.message,
                            },
                        },
                    };
                } else {
                    return null;
                }
            }
        }),
    ].filter((rule) => rule);

    //Concatenate visibility rules
    let visibilityConditions = null;
    const visibility = currRules.visibility;

    if (visibility.advancedMode) {
        visibilityConditions =
            visibility.advancedVisibility === '' ? null : parseJsonString(visibility.advancedVisibility);
    } else {
        if (visibility.conditions && visibility.conditions.length > 0) {
            const conditions = visibility.conditions.filter((condition) => {
                return condition.fact !== '' || condition.operator !== '' || condition.value !== '';
            });

            visibilityConditions = { [visibility.booleanOperator]: conditions };
        } else {
            visibilityConditions = null;
        }
    }

    return { rules: validationRules, visibilityConditions };
};

const parseJsonString = (str) => {
    try {
        return JSON.parse(str);
    } catch (e) {
        return null;
    }
};
